module.exports = __webpack_public_path__ + "static/media/cloud-icon.57fe59b5.png";